import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'transaction/:transactionId',
    loadComponent: () =>
      import('./features/components/transaction/transaction.component').then(
        (c) => c.TransactionComponent,
      ),
  },
  {
    path: 'transaction/user/:transactionId',
    loadComponent: () =>
      import('./features/components/verify-transaction/verify-transaction.component').then(
        (c) => c.VerifyTransactionComponent,
      ),
  },
  {
    path: 'pending',
    loadComponent: () =>
      import('./features/components/payment-pending/payment-pending.component').then(
        (c) => c.PaymentPendingComponent,
      ),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./shared/components/not-found/not-found.component').then((c) => c.NotFoundComponent),
  },
];
